/* The Labour tile (decision 1908): each line's totals sit above that line's rows in the List Viewer. */
.lineTotals {
  margin: var(--space-3) 0 var(--space-1);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
}

/* A worker's typed hours, drawn as their own row beside the entries, read quieter than an entry. */
.typedRow td {
  color: var(--text-muted);
}
